import * as Collections from 'typescript-collections';
import { Characteristic, ValueDefinition, DependenciesFilter } from './types';
import { indexOf } from 'typescript-collections/dist/lib/arrays';

export class DoorConfiguration 
{
    public static ModelSelection: number = 1;
    public static Functions: number = 2;
    public static Frame: number = 3;
    public static Measure: number = 4;
    public static DoorLeafSurface: number = 5;
    public static ExteriorAccessory: number = 6;
    public static MountingMaterial: number = 7;
    public static BlindstockMultiplex: number = 8;
    public static FurtherInformation: number = 9;

    private static instance: DoorConfiguration;
    private configuration = new Collections.Dictionary<number, any[]>();

    private constructor() {
        this.configuration.setValue(DoorConfiguration.ModelSelection, new Array());
        this.configuration.setValue(DoorConfiguration.Functions, new Array());
        this.configuration.setValue(DoorConfiguration.Frame, new Array());
        this.configuration.setValue(DoorConfiguration.Measure, new Array());
        this.configuration.setValue(DoorConfiguration.DoorLeafSurface, new Array());
        this.configuration.setValue(DoorConfiguration.ExteriorAccessory, new Array());
        this.configuration.setValue(DoorConfiguration.MountingMaterial, new Array());
        this.configuration.setValue(DoorConfiguration.BlindstockMultiplex, new Array());
        this.configuration.setValue(DoorConfiguration.FurtherInformation, new Array());
    }

    static get Instance() { 
        if (this.instance === null || typeof this.instance === 'undefined') {
            this.instance = new DoorConfiguration();
        }
        return this.instance;
    }

    // Adds or Replaces the whole Characteristic Object in list.
    // Checks if Id of previous ValueCode is different from Id of selected ValueCode then it replaces the whole Characteristic Object.
    // Used for Adding or Replacing Defined Value Codes.
    public Add(context: number, characteristic: any) {
        const array = this.configuration.getValue(context);
        if (array != null) {
            if (array.length === 0) {
                array.push(characteristic);
            } else {
                const filteredCharacteristic: any = array.filter((item: any) => item.code === characteristic.code);
                if (filteredCharacteristic.length !== 0) {
                    if (filteredCharacteristic[0].value.id !== characteristic.value.id) {
                        const characteristicIndex: number = array.indexOf(filteredCharacteristic[0]);
                        array.splice(characteristicIndex, 1, characteristic);
                    }
                } else {
                    array.push(characteristic);
                }
            }
        }
    }

    public Delete(context: any, characteristic: any){
        const array = this.configuration.getValue(context);
        if (array != null){
            const find = array.find((f: any) => f.code = characteristic.code)
            const findIndexChar = array.findIndex((f: any) => f.code = characteristic.code)

            if (findIndexChar > -1){
                console.log(find.code)
                array.splice(findIndexChar, 1)
            }
        }
    }

    // Adds or Replaces the whole Characteristic Object in list.
    // Used for Adding or Replacing Numeric Values.
    public AddNumericCharacteristic(context: number, characteristic: any) {
        const array = this.configuration.getValue(context);
        if (array != null) {
            if (array.length === 0) {
                array.push(characteristic);
            } else {
                const filteredCharacteristic: any = array.filter((item: any) => item.code === characteristic.code);
                if (filteredCharacteristic.length !== 0) {
                        const characteristicIndex: number = array.indexOf(filteredCharacteristic[0]);
                        array.splice(characteristicIndex, 1, characteristic);
                } else {
                    array.push(characteristic);
                }
            }
        }
    }

     // Updates only CharacteristicValue value property directly.
    // Used for updating Numeric Values, or Non Defined ValueCode.
    public UpdateCharacteristicValue(context: number, characteristicCode: string, value: number) {
        const array = this.configuration.getValue(context);
        if (array != null) {
            const filteredCharacteristic: any = array.filter((item: any) => item.code === characteristicCode);
            if (filteredCharacteristic.length !== 0) {
                filteredCharacteristic[0].value.value = value;
            }
        }
    }


    // Replaces CharacteristicValue value object.
    // Used for updating value object of CharacteristicValue in general.
    public UpdateCharacteristicValueObject(context: number, characteristicCode: string, valueObject: ValueDefinition) {
        const array = this.configuration.getValue(context);
        if (array != null) {
            const filteredCharacteristic: Characteristic[] = array.filter((item: Characteristic) => item.code === characteristicCode);
            if (filteredCharacteristic.length !== 0) {
                filteredCharacteristic[0].value = valueObject;
            }
        }
    }

    public Get(context: number) {
        return this.configuration.getValue(context);
    }

    public GetCurrentDoorModel() {
        const modelSelectionList: any = this.configuration.getValue(DoorConfiguration.ModelSelection);
        const currentModel = modelSelectionList.filter((x: any) => x.code === 'KTU_MM_MODELL')[0];
        return currentModel;
    }

    public GetCurrentDoorMainFunction() {
        const modelSelectionList: any = this.configuration.getValue(DoorConfiguration.ModelSelection);
        const currentModel = modelSelectionList.filter((x: any) => x.code === 'KTU_MM_HAUPTFUNKTION')[0];
        return currentModel;
    }

    public GetHasTopPannel() {
        const modelSelectionList: any = this.configuration.getValue(DoorConfiguration.ModelSelection);
        const currentModel = modelSelectionList.filter((x: any) => x.code === 'KTU_MM_KOMBI_ST_OL')[0];
        if (typeof currentModel !== 'undefined' && currentModel.value.value.includes('O')) {
            return true;
        } else {
            return false;
        }
    }

    public GetCurrentDoorArticleNumber() {
        const modelSelectionList: any = this.configuration.getValue(DoorConfiguration.ModelSelection);
        const modelSelectionArticleNr = modelSelectionList.filter((x: any) => x.code === 'KTU_MM_ARTIKELNR')[0];
        let articleNumber: string = '';

        if (modelSelectionArticleNr != null && typeof modelSelectionArticleNr !== 'undefined') {
            articleNumber = modelSelectionArticleNr.value.value;

            const functionsList: any = this.configuration.getValue(DoorConfiguration.Functions);

            const functionsAufgehrichtung = functionsList.filter((x: any) =>
                 x.code === 'KTU_MM_AUFGEHRICHTUNG')[0];
            const functionsFalzgeometrie = functionsList.filter((x: any) =>
                 x.code === 'KTU_MM_FALZGEOMETRIE')[0];

            if (functionsAufgehrichtung != null && typeof functionsAufgehrichtung !== 'undefined') {

                articleNumber += '-' + functionsAufgehrichtung.value.value;

                if (functionsFalzgeometrie != null && typeof functionsFalzgeometrie !== 'undefined') {
                    articleNumber += '-' + functionsFalzgeometrie.value.value;

                    const frameList: any = this.configuration.getValue(DoorConfiguration.Frame);
                    const frameZargenKruzform = frameList.filter((x: any) => x.code === 'KTU_MM_ZARGEN_KURZFORM')[0];

                    if (frameZargenKruzform != null && typeof frameZargenKruzform !== 'undefined') {
                        articleNumber += '-' + frameZargenKruzform.value.value;
                    }
                }
            }
        }

        return articleNumber;
    }

    public GetRegisteredMaterials() {
        const materialsToCheck = ['KTU_MM_ZARGE', 'KTU_MM_BLINDSTOCK', 'KTU_MM_FERMACELL', 'KTU_MM_SONDERSTOCK'];
        const registeredMaterials: any = this.configuration.getValue(DoorConfiguration.Frame);
        const materials: any = [];
        materialsToCheck.forEach((element: string) => {
            const registeredMaterial = registeredMaterials.filter((x: any) => x.code === element)[0];
            materials.push(registeredMaterial);
        });

        return materials;
    }

    public ClearConfiguration(context: number) {
        this.configuration.setValue(context, new Array());
        return this.configuration.getValue(context);
    }

    public ClearAllConfiguration(context: number) {      
        this.configuration.setValue(DoorConfiguration.ModelSelection, new Array());
        this.configuration.setValue(DoorConfiguration.Functions, new Array());
        this.configuration.setValue(DoorConfiguration.Frame, new Array());
        this.configuration.setValue(DoorConfiguration.Measure, new Array());
        this.configuration.setValue(DoorConfiguration.DoorLeafSurface, new Array());
        this.configuration.setValue(DoorConfiguration.ExteriorAccessory, new Array());
        this.configuration.setValue(DoorConfiguration.MountingMaterial, new Array());
        this.configuration.setValue(DoorConfiguration.BlindstockMultiplex, new Array());
        this.configuration.setValue(DoorConfiguration.FurtherInformation, new Array());
        return this.configuration;
    }

    public ModelSelectionList() {
        const list: any = this.configuration.getValue(DoorConfiguration.ModelSelection);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });
        return data;
    }

    public FunctionsList() {
        const list: any = this.configuration.getValue(DoorConfiguration.Functions);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });
        return data;
    }
    public FrameList() {
        const list: any = this.configuration.getValue(DoorConfiguration.Frame);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public MeasureList() {
        const list: any = this.configuration.getValue(DoorConfiguration.Measure);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public DoorLeafSurfaceList() {
        const list: any = this.configuration.getValue(DoorConfiguration.DoorLeafSurface);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public ExteriorAccessoryList() {
        const list: any = this.configuration.getValue(DoorConfiguration.ExteriorAccessory);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public MountingMaterialList() {
        const list: any = this.configuration.getValue(DoorConfiguration.MountingMaterial);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public BlindstockMultiplexList() {
        const list: any = this.configuration.getValue(DoorConfiguration.BlindstockMultiplex);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    public FurtherInformationList() {
        const list: any = this.configuration.getValue(DoorConfiguration.FurtherInformation);
        const data: any = [];
        list.array.forEach((element: any) => {
            const tempArr: any = [];
            tempArr.push(element.code);
            tempArr.push(element.value.value);

            data.push(tempArr);
        });

        return data;
    }

    // This method is used to extract the Id-s of charachteristics and values for image resources.
    // Its basically same as GetDependenciesByCharacteristic method below, except this returnes an object telling if all the dependencies are seted up
    // and string tuples are correct, and also the string with tuples.
    public GetResourceDependenciesByCharacteristic(characteristicCode: string, dependenciesFilter?: DependenciesFilter) {
        let dependenciesStr: string = '';
        const dependenciesArr: any = [];
        let filteredAnchor: any;
        let dependencieNotCompleted = false;

        filteredAnchor = resourcesDependencies.filter((characteristic: any) => characteristic.anchor === characteristicCode)[0];

        filteredAnchor.dependencies.forEach((element: any) => {
            const characteristicsList: any = this.configuration.getValue(element.module);
            const characteristic = characteristicsList.filter((x: any) => x.code === element.code)[0];

            if (typeof characteristic !== 'undefined') {
                dependenciesArr.push(characteristic);
            } else {
                dependencieNotCompleted = true;
            }
        });

        dependenciesStr = ArrayToStringValues(dependenciesArr, characteristicCode);

        return {
            dependenciesStr,
            dependencieNotCompleted,
        };
    }

    public GetDependenciesByCharacteristic(characteristicCode: string, dependenciesFilter?: DependenciesFilter) {
        let dependenciesStr: string = '';
        const dependenciesArr: any = [];
        let filteredAnchor: any;

        if (dependenciesFilter === DependenciesFilter.Resources) {
            filteredAnchor = resourcesDependencies.filter((characteristic: any) => characteristic.anchor === characteristicCode)[0];
        } else {
            filteredAnchor = characteristicsDependencies.filter((characteristic: any) => characteristic.anchor === characteristicCode)[0];
        }

        filteredAnchor.dependencies.forEach((element: any) => {
            const characteristicsList: any = this.configuration.getValue(element.module);
            const characteristic = characteristicsList.filter((x: any) => x.code === element.code)[0];
            dependenciesArr.push(characteristic);
        });

        dependenciesStr = ArrayToStringValues(dependenciesArr, characteristicCode);

        return dependenciesStr;
    }
}

function ArrayToStringValues(dependenciesArr: any [], anchor: string): string {
    let stringValues: string = '';
    const lastIndexArray: number = dependenciesArr.length - 1;

    for (const element of dependenciesArr) {
        const elementItem = element;

        try {
            stringValues += elementItem.id + '-' + elementItem.value.id;
        } catch (error) {
            console.log(error);
        }

        if (indexOf(dependenciesArr, elementItem) !== lastIndexArray) {
            stringValues += '|';
        }
    }

    return stringValues;
}

const resourcesDependencies = [
    {
        anchor: 'KTU_MM_AUFGEHRICHTUNG',
        dependencies: [
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FALZGEOMETRIE',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_AUFDOPPELUNG_BS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_AUFDOPPELUNG_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENART',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_BS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_GLASVARIANTE',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_O_BS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_GLASVARIANTE_O',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_GBS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_GLASVARIANTE',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_O_GBS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_GLASVARIANTE_O',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZARGE',
        dependencies: [
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_FALZGEOMETRIE',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },
    {
        anchor: 'CUST_MM_ZERTIFIKATE',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            }
        ]
    },
    {
        anchor: 'CUST_MM_PRUFBERICHTE',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            }
        ]
    },
    {
        anchor: 'CUST_MM_ECB',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            }
        ]
    }
];

const characteristicsDependencies = [
    {
        anchor: 'KTU_MM_AUFGEHRICHTUNG',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FLUCHT_SONDER',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FLUCHT',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_PANIK',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FALZGEOMETRIE',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_SCHLAGL_ANZ_BS',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_SCHLAGL_ANZ_GBS',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'CUST_MM_SCHLAGL_ANZ_W_BS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'CUST_MM_SCHLAGL_ANZ_W_GBS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },

    {
        anchor: 'KTU_MM_SCHLAGL_ANZ_W_BS',
        dependencies: [
            {
                code: 'CUST_MM_SCHLAGL_ANZ_W_BS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_SCHLAGL_ANZ_W_GBS',
        dependencies: [
            {
                code: 'CUST_MM_SCHLAGL_ANZ_W_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor: 'KTU_MM_GLASART',
        dependencies: [ 
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_GLASANSCHLUSS',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZARGEN_KURZFORM',
        dependencies: [
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ARTIKELNR',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FUNKTION_EN179',
        dependencies: [
            {
                code: 'KTU_MM_FLUCHT',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FUNKTION_EN1125',
        dependencies: [
            {
                code: 'KTU_MM_PANIK',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    // {
    //     anchor: 'CUST_MM_FUNKTION_EN179',
    //     dependencies: [
    //         {
    //             code: 'KTU_MM_AUFGEHRICHTUNG',
    //             module: DoorConfiguration.Functions,
    //         },
    //         {
    //             code: 'KTU_MM_FUNKTION_RC',
    //             module: DoorConfiguration.ModelSelection,
    //         },
    //         {
    //             code: 'KTU_MM_MODELL',
    //             module: DoorConfiguration.ModelSelection,
    //         },
    //     ],
    // },
    // {
    //     anchor: 'CUST_MM_FUNKTION_EN1125',
    //     dependencies: [
    //         {
    //             code: 'KTU_MM_AUFGEHRICHTUNG',
    //             module: DoorConfiguration.Functions,
    //         },
    //         {
    //             code: 'KTU_MM_FUNKTION_RC',
    //             module: DoorConfiguration.ModelSelection,
    //         },
    //         {
    //             code: 'KTU_MM_MODELL',
    //             module: DoorConfiguration.ModelSelection,
    //         },
    //     ],
    // },
    {
        anchor: 'CUST_MM_RH_DICHTUNG',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_S',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FUNKTION_BESCHUSS',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_GLASART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_BS',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_GBS',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_GLASVARIANTE',
        dependencies: [
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_GLASART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_O_BS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZIERLEISTENVAR_O_GBS',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_GLASVARIANTE_O',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_GLASART',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_ZARGE',
        dependencies: [
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },
    {
        anchor: 'KTU_MM_BLINDSTOCK',
        dependencies: [
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FERMACELL',
        dependencies: [
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },
    {
        anchor: 'KTU_MM_O_STUMPF',
        dependencies: [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'CUST_MM_ABSENKDICHTUNG',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'CUST_MM_TUER_MASS_SYM',
        dependencies: [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor: 'KTU_MM_SONDERSTOCK',
        dependencies: [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },

    {
        anchor: 'KTU_MM_DREIECKSLEISTE',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },

    {
        anchor: 'KTU_MM_HINTERFUETTERUNG',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },

    {
        anchor: 'KTU_MM_ABSCHLUSSWINKEL',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor: 'KTU_MM_ABSCHLUSSPROFIL_S',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor: 'KTU_MM_ABSCHLUSSPROFIL_W',
        dependencies: [
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor: 'CUST_MM_FUTTERPLATTE',
        dependencies: [
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },

    {
        anchor: 'KTU_MM_FUTTERPLATTE_S',
        dependencies: [
            {
                code: 'CUST_MM_FUTTERPLATTE',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_ZARGE_OBERFL_GBS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ],
    },
    {
        anchor: 'KTU_MM_FUTTERPLATTE_W',
        dependencies: [
            {
                code: 'CUST_MM_FUTTERPLATTE',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_ZARGE_OBERFL_GBS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ],
    },
    {
        anchor: 'CUST_MM_AUFDOPPLUNG',
        dependencies: [
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            // {
            //     code: 'KTU_MM_ZIERLEISTENVAR_GBS',
            //     module: DoorConfiguration.Functions,
            // },
        ],
    },
    {
        anchor: 'KTU_MM_AUFDOPPELUNG_BS',
        dependencies: [
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'KTU_MM_AUFDOPPELUNG_GBS',
        dependencies: [
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor: 'CUST_MM_ZARGE_ART',
        dependencies: [
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
        ],
    },
    {
        anchor : 'KTU_MM_STAFFEL',
        dependencies : [
            {
                code : 'CUST_MM_STAFFEL_FORM',
                module : DoorConfiguration.Measure,
            },
            {
                code : 'KTU_MM_STAFFEL_OBERFLAECHE',
                module : DoorConfiguration.DoorLeafSurface
            },
        ],
    },
    {
        anchor : 'KTU_MM_STAFFEL_OBERFLAECHE',
        dependencies : [
            {
                code : 'CUST_MM_STAFFEL_FORM',
                module : DoorConfiguration.Measure,
            },
        ],
    },
    {
        anchor : 'CUST_MM_STAFFEL_FORM_OBF',
        dependencies : [
            {
                code : 'CUST_MM_STAFFEL_FORM',
                module : DoorConfiguration.Measure,
            },
        ],
    },
    {
        anchor : 'CUST_MM_BESCHLAGFARBE',
        dependencies : [
            {
                code : 'CUST_MM_FLUCHT_PANIK',
                module : DoorConfiguration.Functions,
            },
            {
                code : 'KTU_MM_BESCHLAGSART',
                module : DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'CUST_MM_SCHILDFORM',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_SCHILDFORM',
        dependencies : [
            {
                code : 'KTU_MM_BESCHLAGSART',
                module : DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'CUST_MM_DRUCKERFORM',
        dependencies : [
            {
                code : 'KTU_MM_BESCHLAGSART',
                module : DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'CUST_MM_SCHILDFORM',
                module: DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'CUST_MM_BESCHLAGFARBE',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_OBERFLACHE_TXT',
        dependencies : [
            {
                code : 'KTU_MM_ZARGEN_KURZFORM',
                module : DoorConfiguration.Frame,
            },
            {
                code : 'KTU_MM_FUNKTION_BH',
                module : DoorConfiguration.ModelSelection,
            },
            {
                code : 'KTU_MM_WANDART_BESTAND',
                module : DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor : 'CUST_MM_ZYLINDER',
        dependencies : [
            {
                code: 'KTU_MM_PANIK',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FLUCHT',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_BESCHLAGSART',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_EOEFFNER_1',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_EOEFFNER_2',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_EOEFFNER_3',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_EOEFFNER_4',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TUERSCHLIESSER_1',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TUERSCHLIESSER_2',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TUERSCHLIESSER_3',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TUERSCHLIESSER_4',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'CUST_MM_SPION',
        dependencies : [
            {
                code: 'KTU_MM_GLASVARIANTE',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor : 'KTU_MM_SICHERUNGSKETTE',
        dependencies : [
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ANWENDUNG',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'CUST_MM_KASTENR_AUSSENZYLINDER',
        dependencies : [
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_ANWENDUNG',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TUERFESTSTELLER',
        dependencies : [
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_KABELKANALUEBERGANG',
        dependencies : [
            {
                code: 'CUST_MM_KABELKANALUEBERGANG',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_VERRIEGELUNG_SONDER',
        dependencies : [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor : 'CUST_MM_TRANSPONDER_FUNK',
        dependencies : [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'CUST_MM_VERRIEGELUNG_SONDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_SPION',
        dependencies : [
            {
                code: 'CUST_MM_SPION',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_SPION_1',
        dependencies : [
            {
                code: 'CUST_MM_SPION',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_SPION_2',
        dependencies : [
            {
                code: 'CUST_MM_SPION',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    // new
    {
        anchor : 'KTU_MM_AUSSENZYLINDER',
        dependencies : [
            {
                code: 'CUST_MM_KASTENR_AUSSENZYLINDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_KASTENRIEGELSCHLOSS',
        dependencies : [
            {
                code: 'CUST_MM_KASTENR_AUSSENZYLINDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'CUST_MM_KASTENRIEGELSCHLOSS_FARBE',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_FUNK_SET',
        dependencies : [
            {
                code: 'CUST_MM_TRANSPONDER_FUNK',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TRANSPONDER_SET',
        dependencies : [
            {
                code: 'CUST_MM_TRANSPONDER_FUNK',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_KASTENRIEGELSCHLOSS_FARBE',
        dependencies : [
            {
                code: 'CUST_MM_KASTENR_AUSSENZYLINDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_VERRIEG_STD',
        dependencies : [
            {
                code: 'KTU_MM_VERRIEGELUNG_SONDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_OBERBLENDE',
        dependencies : [
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_O_STUMPF',
                module: DoorConfiguration.Measure,
            },
        ],
    },
    {
        anchor : 'KTU_MM_BESCHLAGSART',
        dependencies : [
            {
                code: 'KTU_MM_FLUCHT',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_PANIK',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_EN1125',
                module: DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'KTU_MM_FUNKTION_EN179',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_FLUCHT_PANIK',
        dependencies : [
            {
                code: 'KTU_MM_FLUCHT',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_PANIK',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'CUST_MM_FUNKTION_EN_E_B',
        dependencies : [
            {
                code: 'KTU_MM_FUNKTION_EN1125',
                module: DoorConfiguration.ExteriorAccessory,
            },
            {
                code: 'KTU_MM_FUNKTION_EN179',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_SICHTBESCHLAG',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'CUST_MM_FUNKTION_EN_E_B',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_TUERSCHLIESSER',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'CUST_MM_EOEFFNER',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_BH',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },
    {
        anchor : 'KTU_MM_RIEGELSCHALTKONTAKT',
        dependencies : [
            {
                code: 'CUST_MM_FLUCHT_PANIK',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor : 'KTU_MM_ZYLINDER_INFO',
        dependencies : [
            {
                code: 'CUST_MM_ZYLINDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TOBERFL_BS',
        dependencies : [
            {
                code: 'KTU_MM_ZIERLEISTENVAR_BS',
                module: DoorConfiguration.Functions,
            },
        ],
    },
    {
        anchor : 'KTU_MM_TOBERFL_GBS',
        dependencies : [
            {
                code: 'KTU_MM_ZIERLEISTENVAR_GBS',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor : 'KTU_MM_TUERBAND',
        dependencies : [
            {
                code: 'CUST_MM_BANDART',
                module: DoorConfiguration.Functions,
            },
        ],
    },

    {
        anchor : 'KTU_MM_AUFSTECKHUELSEN',
        dependencies : [
            {
                code: 'CUST_MM_BANDART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'CUST_MM_AUFSTECKHUELSEN',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ],
    },

    {
        anchor : 'KTU_MM_Z_DICHTUNG',
        dependencies : [
            {
                code: 'CUST_MM_Z_DICHTUNG',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ],
    },

    {
        anchor : 'KTU_MM_FALZ_BS',
        dependencies : [
            {
                code: 'KTU_MM_FALZ_O_BS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ],
    },


    {
        anchor : 'KTU_MM_D2_GES',
        dependencies : [
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_MODELL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FUNKTION_RC',
                module: DoorConfiguration.ModelSelection,
            },
        ],
    },

    {
        anchor : 'KTU_MM_BOHRUNG_AZ',
        dependencies : [
            {
                code: 'KTU_MM_ANWENDUNG',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_AUFGEHRICHTUNG',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_OEFFNUNGSART',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'CUST_MM_KASTENR_AUSSENZYLINDER',
                module: DoorConfiguration.ExteriorAccessory,
            },
        ],
    },
    {
        anchor : 'CUST_MM_MINDESTBESTANDSSTARKE',
        dependencies : [
            {
                code: 'KTU_MM_WANDART_BESTAND',
                module: DoorConfiguration.Functions,
            }
        ]
    },
    {
        anchor : 'KTU_MM_ZIERLEISTEN',
        dependencies : [
            {
                code: 'KTU_MM_ZIERLEISTENART',
                module: DoorConfiguration.Functions,
            },
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            }
        ]
    },

    {
        anchor : 'KTU_MM_D2_METALL_O',
        dependencies : [
            {
                code: 'KTU_MM_KOMBI_ST_OL',
                module: DoorConfiguration.ModelSelection,
            },
            {
                code: 'KTU_MM_FALZ_O_BS',
                module: DoorConfiguration.DoorLeafSurface,
            }
        ]
    },

    {
        anchor : 'KTU_MM_FURNIEROBERFL_BS',
        dependencies : [
            {
                code: 'KTU_MM_TOBERFL_BS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ]
    },

    {
        anchor : 'KTU_MM_FURNIEROBERFL_GBS',
        dependencies : [
            {
                code: 'KTU_MM_TOBERFL_GBS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ]
    },
    {
        anchor : 'KTU_MM_GLANZGRAD_BS',
        dependencies : [
            {
                code: 'KTU_MM_TOBERFL_BS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ]
    },

    {
        anchor : 'KTU_MM_GLANZGRAD_GBS',
        dependencies : [
            {
                code: 'KTU_MM_TOBERFL_GBS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ]
    },
    {
        anchor : 'KTU_MM_FUTTERPL_OBERFL',
        dependencies : [
            {
                code: 'KTU_MM_ZARGEN_KURZFORM',
                module: DoorConfiguration.Frame,
            },
            {
                code: 'KTU_MM_ZARGE_OBERFL_GBS',
                module: DoorConfiguration.DoorLeafSurface,
            },
        ]
    },

    {
        anchor : 'KTU_MM_SPIONBOHRUNG',
        dependencies : [
            {
                code: 'CUST_MM_SPION',
                module : DoorConfiguration.ExteriorAccessory
            },
        ]
    },

    {
        anchor : 'KTU_MM_SPIONHOEHE',
        dependencies : [
            {
                code: 'CUST_MM_SPION',
                module : DoorConfiguration.ExteriorAccessory
            },
        ]
    },

    {
        anchor : 'KTU_MM_BOHRUNG_AZ_IW',
        dependencies : [
            {
                code: 'CUST_MM_KASTENR_AUSSENZYLINDER',
                module : DoorConfiguration.ExteriorAccessory
            },
        ]
    },
    {
        anchor : 'KTU_MM_STAFFEL_FARBE',
        dependencies : [
            {
                code : 'CUST_MM_STAFFEL_FORM',
                module : DoorConfiguration.Measure,
            },
        ],
    },
];

